import { useQuery } from 'react-query';
import { subscriptionAPI } from '../services/api';
import type { PlatformOrganizationFeatures } from '../types/platformOrganization';

export type PlanFeatureKey = keyof Pick<
  PlatformOrganizationFeatures,
  'emailAutomation' | 'advancedReports' | 'auditLog' | 'apiAccess'
>;

export function usePlanFeature(feature: PlanFeatureKey) {
  const query = useQuery(['subscription-current'], () => subscriptionAPI.getCurrent(), {
    staleTime: 60_000
  });

  const summary = query.data?.data?.data;

  return {
    enabled: Boolean(summary?.plan?.features?.[feature]),
    isLoading: query.isLoading,
    summary
  };
}
